import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartStateV2 } from './cart-state.model';

export const selectCartStateV2 = createFeatureSelector<CartStateV2>('cart');

export const selectCartV2 = createSelector(selectCartStateV2, (entities) => entities);
export const selectCartSummaryV2 = createSelector(selectCartStateV2, (entities) => entities.cartSummary);
export const selectCartCoursesV2 = createSelector(selectCartStateV2, (entities) => entities.courses);
export const selectCartItemsV2 = createSelector(selectCartStateV2, (entities) => entities.coursesData);
